import { render } from "./detailPop.vue?vue&type=template&id=363e07ae"
import script from "./detailPop.vue?vue&type=script&lang=js"
export * from "./detailPop.vue?vue&type=script&lang=js"

import "./detailPop.vue?vue&type=style&index=0&id=363e07ae&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/global/detail-pop/detailPop.vue'],['render',render],['__file',"detailPop.vue"]])

export default __exports__